import React, { useState, useEffect } from 'react';
import { BUTTON_COLORS } from '../utils/buttonColors';
import CharacterCounter from '../utils/characterCounter';

const EditableTextArea = ({ 
  value, 
  onSave, 
  onRevert, 
  placeholder = "Enter text...", 
  maxLength = 120, 
  label = "Text",
  loading = false,
  disabled = false 
}) => {
  const [text, setText] = useState(value || '');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setText(value || '');
  }, [value]);

  const handleSave = async () => {
    try {
      await onSave(text);
      setMessage('Updated successfully');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      // Provide more specific error messages based on error type
      let errorMessage = 'Failed to update';
      if (err?.response?.status === 403) {
        errorMessage = 'You are not authorized to edit this comment';
      } else if (err?.response?.status === 404) {
        errorMessage = 'Comment not found';
      } else if (err?.response?.status >= 500) {
        errorMessage = 'Server error. Please try again.';
      } else if (err?.code === 'ERR_NETWORK') {
        errorMessage = 'Network error. Please check your connection.';
      }
      
      setMessage(errorMessage);
      setTimeout(() => setMessage(''), 5000); // Show error longer
      console.error('Save error:', err);
    }
  };

  const handleRevert = () => {
    setText(value || '');
    onRevert();
  };

  const isSaveDisabled = loading || disabled || text.length > maxLength || (text === (value || ''));

  return (
    <div style={{ marginBottom: '20px' }}>
      <h3>{label}</h3>
      {message && (
        <div style={{ 
          color: message.includes('success') ? 'var(--color-success)' : 'var(--color-danger)', 
          fontSize: '14px', 
          marginBottom: '10px' 
        }}>
          {message}
        </div>
      )}
      <div style={{ marginBottom: '20px' }}>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          style={{
            width: '100%',
            minHeight: '80px',
            padding: '10px',
            border: '1px solid var(--color-border)',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'vertical',
            background: 'var(--color-surface)',
            color: 'var(--color-text)'
          }}
          maxLength={maxLength}
          disabled={disabled}
        />
        <CharacterCounter current={text.length} max={maxLength} style={{ marginTop: '5px' }} />
        <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
          <button 
            onClick={handleSave}
            className="btn"
            style={{ backgroundColor: BUTTON_COLORS.SAVE, color: 'white', border: 'none' }}
            disabled={isSaveDisabled}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button 
            onClick={handleRevert}
            className="btn"
            style={{ backgroundColor: BUTTON_COLORS.REVERT, color: '#fff' }}
            disabled={disabled}
          >
            Revert
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditableTextArea;
